<template>
    <div class="modal fade" :id="modalId" tabindex="-1">
    <div class="modal-dialog">
        <div class="modal-content">
        <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">&times;</span></button>
            <h4 class="modal-title">{{title}}</h4>
        </div>
        <div class="modal-body">{{message}}</div>
        <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">取消</button>
            <button type="button" class="btn btn-success" data-dismiss="modal" @click="comfirm">确定</button>
        </div>
        </div>
    </div>
    </div>
</template>
<script>
    export default {
        name : 'ConfirmModal',
        data () {
            return {};
        },
        props : {
            modalId : "",
            title : "",
            message : "",
            body : {}
        },
        methods : {
            comfirm() {
                this.$emit('comfirm', this.body);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/common/modal/confirm/index.vue